import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['submitButton', 'imageLoader']

  connect() {
    this.imageLoaderTarget.addEventListener('image:content-change', _event => {
      this.submitButtonTarget.disabled = false
    })
  }
}
